import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedModelConceptRelationship,
  ModelConceptRelationship,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createDeletedModelConceptClass';
import { replaceDeletedModelConceptRelationshipLabelKey } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/createDeletedModelConceptRelationshipLabel';

export const replaceDeletedModelConceptRelationshipKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkCategory.MODEL_CONCEPT_RELATIONSHIP}-`),
    `${LinkCategory.DELETED_MODEL_CONCEPT_RELATIONSHIP}-`
  );

export const createDeletedModelConceptRelationship = (
  existing: ModelConceptRelationship,
  label: string,
  deletedKeys: Set<string>
): DeletedModelConceptRelationship => ({
  key: replaceDeletedModelConceptRelationshipKey(existing.key),
  from:
    existing.from && deletedKeys.has(existing.from)
      ? replaceDeletedModelConceptClassKey(existing.from)
      : existing.from,
  value: existing.value,
  text: label,
  to:
    existing.to && deletedKeys.has(existing.to)
      ? replaceDeletedModelConceptClassKey(existing.to)
      : existing.to,
  labelKeys: existing.labelKeys.map(
    replaceDeletedModelConceptRelationshipLabelKey
  ),
  category: LinkCategory.DELETED_MODEL_CONCEPT_RELATIONSHIP,
  points: existing.points,
});
